module.exports = __webpack_public_path__ + "img/dropdownEle.d7394f2b.svg";